import { ConfigKeys } from './ConfigKeys'
import { ToggleableModules } from './toggleable-modules/ToggleableModules'

export const ConfigDefaultValues: Record<ConfigKeys, any> = {
  [ConfigKeys.DO_KDY_MUZE_ASISTENT_ZMENIT_NABIZENY_CAS]: 14400,
  [ConfigKeys.DO_KDY_MUSI_ASISTENT_POTVRDIT_ASISTENCI]: 14400,
  [ConfigKeys.ODKDY_JE_POZDE_OBJEDNANA_ASISTENCE_HODINY]: 14400,
  [ConfigKeys.POZDE_OBJEDNANA_JESTLI_SE_VZTAHUJE_NA_KOORDINATORY]: true,
  [ConfigKeys.ODKDY_JE_POZDE_ZRUSENA_JIZ_POTVRZENA_ASISTENCE_HODINY]: 7200,
  [ConfigKeys.DOKDY_JE_MOZNA_EDITACE_PROBEHLYCH_ASISTENCI_DNY]: 7,
  [ConfigKeys.ORDINACNI_HODINY_START_NO_TZ]: '0700',
  [ConfigKeys.ORDINACNI_HODINY_END_NO_TZ]: '1400',
  [ConfigKeys.VYCHOZI_DOBA_PREJEZDU_MINUTY]: 30,
  [ConfigKeys.TOGGLEABLE_MODULES]: new ToggleableModules(),
  [ConfigKeys.ASSISTANT_LIST_CUSTOM_COLUMNS]: 'birthDate',
  [ConfigKeys.STORNO_BEZ_LIMITU_O_VIKENDECH_A_SVATCICH]: false,

  [ConfigKeys.ORGANIZACE_NAZEV]: '',
  [ConfigKeys.ORGANIZACE_ADRESA_SIDLA]: '',
  [ConfigKeys.ORGANIZACE_LOGO]: '',
  [ConfigKeys.ORGANIZACE_TELEFON]: '',
  [ConfigKeys.ORGANIZACE_CISLO_UCTU]: '',
  [ConfigKeys.ORGANIZACE_ICO]: '',
  [ConfigKeys.ORGANIZACE_BANKA]: '',

  [ConfigKeys.DEPRECATED_KONTAKTY]: '',

  [ConfigKeys.JOURNAL_ENTRY_HISTORY_ENABLED]: false,

  [ConfigKeys.CLIENT_CANCEL_FEE_MODE]: 'zero',

  [ConfigKeys.WORK_ATTENDANCE_BALANCE_FROM]: '',
}
